import {useMutation} from '@tanstack/react-query';
import type {
  UpdateDraftProjectParams,
  UpdateDraftProjectResponse,
} from '@contentlab/api/project/types';
import projectUpdaters from '@contentlab/api/project/updaters';

interface UseUpdateDraftProjectOptions {
  onSuccess?: (
    data: UpdateDraftProjectResponse,
    requestParams: UpdateDraftProjectParams
  ) => void;
  onError?: (error: Error) => void;
}

function useUpdateDraftProject(options: UseUpdateDraftProjectOptions = {}) {
  const {onSuccess, onError} = options;

  return useMutation<
    UpdateDraftProjectResponse,
    Error,
    {projectId: string; params: UpdateDraftProjectParams}
  >({
    mutationFn: ({
      projectId,
      params,
    }: {
      projectId: string;
      params: UpdateDraftProjectParams;
    }) => projectUpdaters.updateDraftProject(projectId, params),
    onSuccess: (data, variables) => onSuccess?.(data, variables.params),
    onError,
  });
}

export default useUpdateDraftProject;
